var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_112_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 112 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uAD6C\\uC131_\\uC694\\uC18C_103_1",
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 103 \\u2013 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1263",
    "data-name": "\\uD0C0\\uC6D0 1263",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0081f5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10269",
    "data-name": "\\uD328\\uC2A4 10269",
    d: "M10.044-5.758h1.992L9.395,3.622H7.524L6.391-1.864,6.06-3.677,5.73-1.864,4.6,3.622H2.777L.117-5.758H2.2L3.439-.387l.267,1.5L3.98-.355l1.056-5.4H7.1L8.218-.387l.286,1.5L8.79-.33Z",
    transform: "translate(4.15 11.492)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection02);
export default __webpack_public_path__ + "static/media/inspection_02.1b2c514dfc25ca1f9304ae743a361912.svg";
export { ForwardRef as ReactComponent };